<template>
  <span class="question-type-badge">
    <img v-if="icon" class="badge-icon" :src="icon" alt="">{{ label }}
  </span>
</template>

<script>
import { i18nPrefix } from './common'
import singleSelectIcon from '@/assets/images/question-ui/single-select.svg'
import multiSelectIcon from '@/assets/images/question-ui/multi-select.svg'
import textIcon from '@/assets/images/question-ui/text.svg'
export default {
  name: 'QuestionTypeBadge',
  props: {
    questionType: {
      type: String,
      default: ''
    },
    labelOverride: {
      type: String,
      default: ''
    }
  },
  computed: {
    label () {
      return this.labelOverride || this.$t(`${i18nPrefix}.questionTypeShort.${this.questionType}`)
    },
    icon () {
      return ['dropdown', 'single_select'].includes(this.questionType) ? singleSelectIcon : ['checkbox', 'multiple_select'].includes(this.questionType) ? multiSelectIcon : this.questionType === 'text' ? textIcon : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.question-type-badge{
  display:inline-flex;
  align-items:center;
  gap:4px;
  padding:4px 8px;
  border:1px solid #cdecf7;
  border-radius:21px;
  background:#f1fbff;
  color:#0096cc;
  font-size:10px;
  line-height:10px;
  font-weight:500;
  white-space:nowrap
  .badge-icon{
    width:12px;
    height:12px
  }
}
</style>
